import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import type { Color } from "@msuite/utils/colors";
import type { Enums } from "@msuite/utils/types";
import { INCOMING_INVOICE_KIND_LABEL } from "./incoming-invoice-kind-labels";

/** Props Interface */
interface IncomingInvoiceKindTagProps {
	kind: Enums<"incomingInvoiceKind">;
}

const KIND_COLOR: Record<Enums<"incomingInvoiceKind">, Color> = {
	invoice: "blue",
	"partial-invoice": "amber",
	"final-invoice": "violet",
	"credit-note": "emerald",
};

export function IncomingInvoiceKindTag({ kind }: IncomingInvoiceKindTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Tag
			color={KIND_COLOR[kind]}
			variant="plain"
		>
			{t(INCOMING_INVOICE_KIND_LABEL[kind])}
		</Tag>
	);
}
